import React from 'react'
import PropTypes from 'prop-types'
import styles from './index.module.scss'

export default function CalenderContainer ({
  title,
  children
}) {
  return (
    <div className={styles.container}>
      <div className={styles.header}>{title}</div>
      <div className={styles.subcontainer}>{children}</div>
    </div>
  )
}

CalenderContainer.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node
}
